<template>
  <div class="container fluid">
    <v-card>
      <DdAccountsTable />
    </v-card>
  </div>
</template>

<script>
import DdAccountsTable from '@/components/digitalDepots/DdAccountsTable';

export default {
  name: 'DigitalDepotAccountsView',
  components: {
    DdAccountsTable,
  },
  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/digitalDepots/DdAccountsView.vue